(ns practitest.frontend.common-entities.link-entities-events
  (:require
    [ajax.core :as ajax]
    [clojure.string :as str]
    [practitest.frontend.common-entities.metadata :refer [entities-metadata]]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.events :as events]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.utils :refer [track!]]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.components.notifications :as notifications]
    [re-frame.core :as re-frame]))

(re-frame/reg-event-fx
  ::unlink-entity
  (fn [{db :db} [_ entity-type entity-id traceability-entity]]
    (let [unlink-entity-url (get-in entities-metadata [entity-type :urls :unlink-entity])]
      {:db (update db :progress conj [::unlink-entity (:id traceability-entity)])
       :http-xhrio
       {:method          :post
        :uri             (broutes/get-url unlink-entity-url {:p_id (subs/get-current-project-id db)
                                                             :id entity-id})
        :params          {:traceability_entity_type (:type traceability-entity)
                          :traceability_entity_id (:id traceability-entity)}
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::unlink-entity-success entity-type entity-id traceability-entity]
        :on-failure      [::unlink-entity-failure traceability-entity]}})))

(re-frame/reg-event-db
  ::unlink-entity-success
  (fn [db [_ entity-type entity-id traceability-entity response]]
    (track! "Delete Entity from traceability" entity-type)

    (-> (if-let [entity (:entity response)]
          (assoc-in db [:entity entity-type :current] (assoc entity :type entity-type))
          db)
        (update :progress disj [::unlink-entity (:id traceability-entity)])
        (assoc-in [:entity entity-type :traceability] (:traceability response)))))

(re-frame/reg-event-fx
  ::unlink-entity-failure
  (fn [{db :db} [event-id traceability-entity error]]
    {:db (-> db
             (update :progress disj [::unlink-entity (:id traceability-entity)]))
     :dispatch [::events/api-error event-id
                (get-translation "entity.traceability.delete-error"
                                 "Error deleting traceability item")]}))

(defn link-entities! [refresh-event hide-event {:keys [db]} [event-id linked-entities-type state-key entity-ids]]
  (let [current-entity (:current-entity db)
        link-enetities-url (get-in entities-metadata [current-entity :urls :link-entities])]
    {:db (update db :progress conj event-id)
     :fx [[:http-xhrio {:method :post
                        :uri (broutes/get-url link-enetities-url
                                              {:p_id (subs/get-current-project-id db)
                                               :id (subs/get-current-entity-id db current-entity)})
                        :format (ajax/json-request-format)
                        :params {:entity_type linked-entities-type
                                 :entity_ids entity-ids
                                 :current_entity current-entity}
                        :response-format (ajax/json-response-format {:keywords? true})
                        :on-success [::link-entities-succeeded event-id refresh-event hide-event state-key]
                        :on-failure [::link-entities-failed event-id hide-event state-key]}]]}))

(defn fetch-entity [on-success {:keys [db]} [event-id linked-entities-type grid-query]]
  (let [query-map (merge grid-query {:entity_type linked-entities-type
                                     :timestamp (.getTime (js/Date.))
                                     :current_entity (:current-entity db)})
        current-entity (:current-entity db)
        project-id (subs/get-current-project-id db)
        entity-id (subs/get-current-entity-id db current-entity)]
    {:db (update db :progress conj event-id)
     :fx [[:dispatch [::f3.entity-form/fetch-entity {:form-id :requirement-form
                                                     :entity-type current-entity
                                                     :entity-id entity-id
                                                     :project-id project-id
                                                     :new? false}]]]}))

(defn got-linked-entities [op state-key db [_ {:keys [data _per_page current_page total_count full]}]]
  (-> db
      (assoc-in [:entity (:current-entity db) :stale-grid?] false)
      (update-in [:entity (:current-entity db) state-key] assoc
                 :data data
                 :selection #{}
                 :current-page current_page
                 ;:per-page per_page
                 :total-count total_count
                 :full-data? (boolean full))
                 ;; Sync filters
                 ;:current-filter-fetched (get-in sb [:entity :milestone state-key :current-filter-selected])
      (update :progress disj op)))

(re-frame/reg-event-db
  ::hide-link-entities-modal
  (fn [db [_ state-key]]
    (assoc-in db [:entity (:current-entity db) state-key :show-link-entities-modal?] false)))

(re-frame/reg-event-fx
  ::link-entities-succeeded
  (fn [{:keys [db]} [_ caller-id refresh-event hide-event state-key _]]
    {:db (update db :progress disj caller-id)
     :fx [[:dispatch refresh-event]
          [:dispatch [::events/fetch-history]]
          [:dispatch [hide-event state-key]]]}))

(re-frame/reg-event-fx
  ::link-entities-failed
  (fn [{:keys [db]} [_ caller-id hide-event _ result]]
    (let [message (->> (get-in result [:response :errors])
                       (cons "Note: Failed to link entities.")
                       (str/join "<br/><br/>"))]
      {:db (update db :progress disj caller-id)
       :fx [[:dispatch [::events/api-error caller-id {:message message}]]
            [:dispatch [hide-event]]]})))

(re-frame/reg-event-db
  ::got-linked-entities
  (partial got-linked-entities ::fetch-linked-requirements :requirements-state))

(re-frame/reg-event-fx
  ::fetch-entity
  (partial fetch-entity ::got-linked-entities))

(re-frame/reg-event-fx
  ::link-entities
  (partial link-entities! [::fetch-entity] ::hide-link-entities-modal))

(defn to-staged-traceability-hash
  [{:keys [id project_id name display_id
           status run_status issue_status requirement_status
           created_at updated_at] :as item} linked-entities-type]
  {:id         id
   :project_id project_id
   :type       linked-entities-type
   :name       (if (= linked-entities-type "test")
                 name
                 (:title name))
   :display_id display_id
   :status     (cond
                 (= linked-entities-type "issue") issue_status
                 (= linked-entities-type "requirement") requirement_status
                 :else status)
   :run_status run_status
   :created_at created_at
   :updated_at updated_at})

(defn update-staged-traceability
  [traceability linked-entities-type entities-data ids-to-link]
  (let [ids (set (map str ids-to-link))
        plural-key (get-in entities-metadata [linked-entities-type :plural-key])
        type-str (name linked-entities-type)
        entities (filterv #(contains? ids (str (:id %))) entities-data)]
    (assoc traceability plural-key (mapv #(to-staged-traceability-hash % type-str) entities))))

(defn stage-link-entities!
  [hide-event {:keys [db]} [event-id linked-entities-type state-key entity-ids]]
  (let [current-entity (:current-entity db)
        form-id (get-in entities-metadata [current-entity :form-id])
        linked-ids-key (get-in entities-metadata [linked-entities-type :linked-ids-key])
        already-linked-ids (let [ids (get-in db [:form-states2 form-id linked-ids-key])]
                             (cond
                               (set? ids) ids
                               ids #{ids}
                               :else #{}))
        all-linked-ids (into already-linked-ids entity-ids)
        linked-entities-data (get-in db [:entity current-entity state-key :data])
        traceability (get-in db [:entity current-entity :traceability])
        updated-traceability (update-staged-traceability traceability linked-entities-type linked-entities-data all-linked-ids)]
    {:db (-> db
             (update :progress conj event-id)
             (assoc-in [:form-states2 form-id linked-ids-key] all-linked-ids)
             (assoc-in [:entity current-entity :traceability] updated-traceability))
     :fx [[:dispatch [hide-event state-key]]]}))

(re-frame/reg-event-fx
  ::stage-link-entities
  (partial stage-link-entities! ::hide-link-entities-modal))

(re-frame/reg-event-db
  ::stage-unlink-entity
  (fn [db [_ item]]
    (let [current-entity (:current-entity db)
          form-id (get-in entities-metadata [current-entity :form-id])
          entity-type (keyword (:type item))
          linked-ids-key (get-in entities-metadata [entity-type :linked-ids-key])
          plural-entity-key (get-in entities-metadata [entity-type :plural-key])
          item-id (:id item)]
      (-> db
          (update-in [:form-states2 form-id linked-ids-key] disj item-id)
          (update-in [:entity current-entity :traceability plural-entity-key]
                     #(filterv (fn [e] (not= (:id e) item-id)) %))))))

(re-frame/reg-event-fx
 ::add-entities-by-id-succeeded
 (fn [{:keys [db]} [_ event-id form-id field _]]
   {:db (-> db 
            (assoc-in [:form-states2 form-id :fields field :value] "")
            (update :progress disj event-id))
    :fx [[:dispatch [::fetch-entity]] 
         [:dispatch [::events/fetch-history]]
         [:dispatch [::notifications/success2 "Entities succesfully linked"]]]}))

(re-frame/reg-event-fx
 ::add-entities-by-id-failed
 (fn [{:keys [db]} [_ event-id result]]
   (let [message (->> (get-in result [:response :errors])
                      (cons "Note: Failed to link entities.")
                      (str/join "<br/><br/>"))]
     {:db (update db :progress disj event-id)
      ;; we fetch entities even if returned errors 
      ;; for the case when some entity added but other is not
      :fx [[:dispatch [::fetch-entity]]
           [:dispatch [::events/api-error event-id {:message message}]]]})))

(re-frame/reg-event-fx
 ::add-entities-by-id
 (fn [{:keys [db]} [_ linked-entities-type entity-ids-to-add form-id field _]]
   (let [current-entity (:current-entity db)
         current-entity-id (subs/get-current-entity-id db current-entity)
         event-id (keyword (str "adding-linked-" linked-entities-type "-id-" current-entity-id))
         link-enetities-url (get-in entities-metadata [current-entity :urls :link-entities])]
     {:db (update db :progress conj event-id)
      :fx [[:http-xhrio {:method :post
                         :uri (broutes/get-url link-enetities-url
                                               {:p_id (subs/get-current-project-id db)
                                                :id current-entity-id})
                         :format (ajax/json-request-format)
                         :params {:entity_type linked-entities-type
                                  :entity_ids []
                                  :display_entity_ids entity-ids-to-add
                                  :current_entity current-entity
                                  :convert_to_system_ids true}
                         :response-format (ajax/json-response-format {:keywords? true})
                         :on-success [::add-entities-by-id-succeeded event-id form-id field]
                         :on-failure [::add-entities-by-id-failed event-id]}]]})))
